module.exports = __webpack_public_path__ + "img/教育教学369.bfd4417b.png";